import { PkSpinner } from '@uefadigital/panenka-react';
import clsx from 'clsx';
import { memo, useMemo } from 'react';

import { useDrawStore } from '@apps/draw/store';
import { useDrawVideoPlayerOptions, useLiveblog } from '@apps/draw-centre/hooks';
import { useDrawCentreOptions } from '@apps/draw-centre/store';
import UefaComLb from '@apps/liveblog/app';

import * as styles from './styles.module.scss';

const DrawCommentary = () => {
  const {
    options: { liveblogOptions },
  } = useDrawCentreOptions();

  const { drawNoVideo } = useDrawVideoPlayerOptions();

  const draw = useDrawStore((state) => state.draw);

  const { liveblog, isLoading } = useLiveblog();

  const modifiedLiveblogOptions = useMemo(() => {
    if (liveblog?.id) {
      return {
        ...liveblogOptions,
        blogId: liveblog.id,
        blogPubDate: new Date(liveblog.publicationDate).toISOString(),
        loadOnScroll: true,
        showLoadMore: false,
        hideNewPosts: true,
        showNewPostsOnScroll: true,
        autoStart: true,
        draw: draw,
      };
    }
    return liveblogOptions;
  }, [draw, liveblog, liveblogOptions]);

  if (isLoading)
    return (
      <div className={styles.loading}>
        <PkSpinner />
      </div>
    );

  return (
    <div className={clsx(styles.lbBody, drawNoVideo && styles.lbBodyNoVideo)}>
      <UefaComLb options={modifiedLiveblogOptions} />
    </div>
  );
};

export default memo(DrawCommentary);
